import React from 'react';
import { useMetaPixel } from './components/MetaPixel';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { FrameworkSection } from './components/FrameworkSection';
import { ValueStackSection } from './components/ValueStackSection';
import { ClosingSection } from './components/ClosingSection';
export function App() {
  useMetaPixel();
  return <main className="min-h-screen bg-navy selection:bg-gold/30" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainSection data-id="element-2" />
      <FrameworkSection data-id="element-3" />
      <ValueStackSection data-id="element-4" />
      <ClosingSection data-id="element-5" />
    </main>;
}